import React from 'react';
import { CURRENCY_CODE } from '../constants/currencyConfig';
import {
  ArrowLeft,
  Calendar,
  DollarSign,
  Tag,
} from 'lucide-react';

const ReportForm = ({
  title,
  fields,
  onSubmit,
  onCancel,
  loading,
  submitButtonText,
  children
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <form onSubmit={onSubmit} className="space-y-4">
        {fields.map(field => (
          <div key={field.name}>
            <label htmlFor={field.name} className="block text-sm font-medium text-gray-700">{field.label}</label>
            {field.type === 'text' && (
              <input
                type="text"
                id={field.name}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                value={field.value}
                onChange={field.onChange}
                required={field.required}
              />
            )}
            {field.type === 'textarea' && (
              <textarea
                id={field.name}
                rows="3"
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                value={field.value}
                onChange={field.onChange}
              />
            )}
            {field.type === 'number' && (
              <div className="mt-1 relative rounded-md shadow-sm">
                <input
                  type="number"
                  name={field.name}
                  id={field.name}
                  className="block w-full pl-7 pr-12 border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                  placeholder="000000"
                  aria-describedby="price-addon"
                  value={field.value}
                  onChange={field.onChange}
                  required={field.required}
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <span className="text-gray-500 sm:text-sm" id="price-addon">
                    {CURRENCY_CODE}
                  </span>
                </div>
              </div>
            )}
            {field.type === 'date' && (
              <div className="mt-1 relative rounded-md shadow-sm">
                
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Calendar className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </div>
                <input
                  type="date"
                  name={field.name}
                  id={field.name}
                  className="block w-full pl-10 border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
                  value={field.value}
                  onChange={field.onChange}
                  required={field.required}
                />
              </div>
            )}
            {field.type === 'select' && (
            <div className="mt-1">
              <select
                id={field.name}
                name={field.name}
                className="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
                value={field.value}
                onChange={field.onChange}
                required={field.required}
              >
                <option value="">
                  {field.label === 'Category' || field.label === 'Expense Category' ? 'Select a category' : 'Select an option'}
                </option>
                {field.options && Array.isArray(field.options) && field.options.map(option => (
                  <option
                    key={option.id || option.value}
                    value={option.id || option.value}
                  >
                    {option.name || option.label}
                  </option>
                ))}
              </select>
            </div>
          )}
            {field.type === 'checkbox' && (
              <div className="flex items-start">
                <div className="flex items-center h-5">
                  <input
                    id={field.name}
                    name={field.name}
                    type="checkbox"
                    className="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300 rounded"
                    checked={field.value}
                    onChange={field.onChange}
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label htmlFor={field.name} className="font-medium text-gray-700">{field.label}</label>
                  {field.description && <p className="text-gray-500">{field.description}</p>}
                </div>
              </div>
            )}
          </div>
        ))}
        {children}
        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            disabled={loading}
          >
            {loading ? 'Loading...' : submitButtonText}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReportForm;
